import Flickity from 'flickity'
import on from 'dom-event'
import debounce from 'lodash/debounce'

export default el => {
  const selectors = {
    slider: '.js-featured-collection-slider',
    slide: '.js-featured-collection-slide'
  }

  const slides = [...el.querySelectorAll(selectors.slide)]

  const featuredCollectionSlider = () => {
    return new Flickity(selectors.slider, {
      prevNextButtons: false,
      pageDots: true,
      cellAlign: 'left',
      freeScroll: false,
      wrapAround: true,
      contain: true
    })
  }

  checkSliderActive()

  on(window, 'resize', debounce(checkSliderActive, 300))

  function checkSliderActive () {
    if (window.innerWidth <= 1023 && slides.length > 1) {
      featuredCollectionSlider()
    } else {
      featuredCollectionSlider().destroy()
    }
  }
}
